// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { MvpApiCheckDeviceValidityData, MvpApiCheckDeviceValidityResponses, MvpApiCloneReviewTasksData, MvpApiCloneReviewTasksResponses, MvpApiCompleteJobData, MvpApiCompleteJobResponses, MvpApiCompleteJobTaskData, MvpApiCompleteJobTaskResponses, MvpApiCreateBenchmarkJobsData, MvpApiCreateBenchmarkJobsResponses, MvpApiCreateChargerData, MvpApiCreateChargerResponses, MvpApiCreateDeviceData, MvpApiCreateDeviceResponses, MvpApiCreateJobData, MvpApiCreateJobResponses, MvpApiCreateJobTasksData, MvpApiCreateJobTasksResponses, MvpApiCreatePlanogramData, MvpApiCreatePlanogramImagesData, MvpApiCreatePlanogramImagesResponses, MvpApiCreatePlanogramResponses, MvpApiCreateReviewTasksData, MvpApiCreateReviewTasksResponses, MvpApiCreateVideoData, MvpApiCreateVideoExportRequestData, MvpApiCreateVideoExportRequestResponses, MvpApiCreateVideoResponses, MvpApiCreateVideoTagNameData, MvpApiCreateVideoTagNameResponses, MvpApiCreateVideoTimeTagData, MvpApiCreateVideoTimeTagResponses, MvpApiDeleteVideoTimeTagData, MvpApiDeleteVideoTimeTagResponses, MvpApiErrorOutJobData, MvpApiErrorOutJobResponses, MvpApiGetBenchmarkJobMetricsData, MvpApiGetBenchmarkJobMetricsResponses, MvpApiGetCompanyData, MvpApiGetCompanyResponses, MvpApiGetDevicesInventoryData, MvpApiGetDevicesInventoryResponses, MvpApiGetImageGalleryUrlsData, MvpApiGetImageGalleryUrlsResponses, MvpApiGetImageRotationData, MvpApiGetImageRotationResponses, MvpApiGetImageUrlsData, MvpApiGetImageUrlsResponses, MvpApiGetInjectionPoolStatusData, MvpApiGetInjectionPoolStatusResponses, MvpApiGetJobData, MvpApiGetJobFileData, MvpApiGetJobFileResponses, MvpApiGetJobLogTailData, MvpApiGetJobLogTailResponses, MvpApiGetJobResponses, MvpApiGetJobTaskData, MvpApiGetJobTaskParcelsData, MvpApiGetJobTaskParcelsResponses, MvpApiGetJobTaskResponses, MvpApiGetMyInjectedBenchmarkMetricsData, MvpApiGetMyInjectedBenchmarkMetricsResponses, MvpApiGetNextPendingJobTaskData, MvpApiGetNextPendingJobTaskResponses, MvpApiGetOosEventBatchData, MvpApiGetOosEventBatchResponses, MvpApiGetOosEventFromBufferData, MvpApiGetOosEventFromBufferResponses, MvpApiGetOosParcelData, MvpApiGetOosParcelResponses, MvpApiGetPlanogramData, MvpApiGetPlanogramImageData, MvpApiGetPlanogramImageResponses, MvpApiGetPlanogramLabelData, MvpApiGetPlanogramLabelResponses, MvpApiGetPlanogramResponses, MvpApiGetSignedImageUrlData, MvpApiGetSignedImageUrlResponses, MvpApiGetSingleImageUrlsData, MvpApiGetSingleImageUrlsResponses, MvpApiGetStoreData, MvpApiGetStoreResponses, MvpApiGetStoresInventoryData, MvpApiGetStoresInventoryResponses, MvpApiGetVideoData, MvpApiGetVideoExportRequestData, MvpApiGetVideoExportRequestResponses, MvpApiGetVideoResponses, MvpApiGetVideoTagNameData, MvpApiGetVideoTagNameResponses, MvpApiGetVideoTagsForStoreData, MvpApiGetVideoTagsForStoreResponses, MvpApiGetVideoTimeTagData, MvpApiGetVideoTimeTagResponses, MvpApiListAllJobTasksData, MvpApiListAllJobTasksResponses, MvpApiListChargersData, MvpApiListChargersResponses, MvpApiListCompaniesData, MvpApiListCompaniesResponses, MvpApiListCvUpdateRequestsData, MvpApiListCvUpdateRequestsResponses, MvpApiListCvUpdateResponsesData, MvpApiListCvUpdateResponsesResponses, MvpApiListDevicePingsData, MvpApiListDevicePingsResponses, MvpApiListDevicesData, MvpApiListDevicesResponses, MvpApiListInjectedBenchmarkMetricsData, MvpApiListInjectedBenchmarkMetricsResponses, MvpApiListJobsData, MvpApiListJobsInFlightData, MvpApiListJobsInFlightResponses, MvpApiListJobsResponses, MvpApiListJobTasksData, MvpApiListJobTasksResponses, MvpApiListMyBenchmarkJobsData, MvpApiListMyBenchmarkJobsResponses, MvpApiListOosEventBatchesData, MvpApiListOosEventBatchesResponses, MvpApiListOosEventBufferData, MvpApiListOosEventBufferResponses, MvpApiListOosParcelsData, MvpApiListOosParcelsResponses, MvpApiListPlanogramImagesData, MvpApiListPlanogramImagesResponses, MvpApiListPlanogramsData, MvpApiListPlanogramsResponses, MvpApiListStorePingsData, MvpApiListStorePingsResponses, MvpApiListStorePongsData, MvpApiListStorePongsResponses, MvpApiListStoresData, MvpApiListStoresResponses, MvpApiListToolWebsitesData, MvpApiListToolWebsitesResponses, MvpApiListVideoCapturesData, MvpApiListVideoCapturesResponses, MvpApiListVideoExportsData, MvpApiListVideoExportsResponses, MvpApiListVideoJobsData, MvpApiListVideoJobsResponses, MvpApiListVideosData, MvpApiListVideosResponses, MvpApiListVideoTagNamesData, MvpApiListVideoTagNamesResponses, MvpApiListVideoTimeTagsData, MvpApiListVideoTimeTagsResponses, MvpApiMarkStartedJobData, MvpApiMarkStartedJobResponses, MvpApiRefreshStoreDevicesData, MvpApiRefreshStoreDevicesResponses, MvpApiRegisterImagesData, MvpApiRegisterImagesResponses, MvpApiRegisterVideoImagesData, MvpApiRegisterVideoImagesResponses, MvpApiShouldShowStaffToolData, MvpApiShouldShowStaffToolResponses, MvpApiSignImgixUrlData, MvpApiSignImgixUrlResponses, MvpApiSkipJobTaskData, MvpApiSkipJobTaskResponses, MvpApiStopJobData, MvpApiStopJobResponses, MvpApiTaskActivityData, MvpApiTaskActivityResponses, MvpApiUpdateChargerData, MvpApiUpdateChargerResponses, MvpApiUpdateDeviceData, MvpApiUpdateDeviceResponses, MvpApiUpdateJobData, MvpApiUpdateJobResponses, MvpApiUpdateJobStageData, MvpApiUpdateJobStageResponses, MvpApiUpdateJobTaskMetadataData, MvpApiUpdateJobTaskMetadataResponses, MvpApiUpdatePlanogramLabelData, MvpApiUpdatePlanogramLabelResponses, MvpApiUpdateStoreData, MvpApiUpdateStoreResponses, MvpApiUpdateVideoPropertyDataData, MvpApiUpdateVideoPropertyDataResponses, MvpApiUpdateVideoStatusData, MvpApiUpdateVideoStatusResponses, MvpApiUpdateVideoTagNameData, MvpApiUpdateVideoTagNameResponses, MvpApiUpdateVideoTagsData, MvpApiUpdateVideoTagsResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * List Companies
 */
export const mvpApiListCompanies = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListCompaniesData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListCompaniesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/companies',
    ...options
});

/**
 * Get Company
 */
export const mvpApiGetCompany = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetCompanyData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetCompanyResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/companies/{company_id}',
    ...options
});

/**
 * List Stores
 */
export const mvpApiListStores = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListStoresData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListStoresResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/stores',
    ...options
});

/**
 * Get Store
 */
export const mvpApiGetStore = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetStoreData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetStoreResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/stores/{store_id}',
    ...options
});

/**
 * Update Store
 */
export const mvpApiUpdateStore = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdateStoreData, ThrowOnError>) => (options.client ?? client).patch<MvpApiUpdateStoreResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/stores/{store_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Refresh Store Devices
 */
export const mvpApiRefreshStoreDevices = <ThrowOnError extends boolean = false>(options: Options<MvpApiRefreshStoreDevicesData, ThrowOnError>) => (options.client ?? client).post<MvpApiRefreshStoreDevicesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/stores/{store_id}/refresh-devices',
    ...options
});

/**
 * List Devices
 */
export const mvpApiListDevices = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListDevicesData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListDevicesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/devices',
    ...options
});

/**
 * Create Device
 */
export const mvpApiCreateDevice = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateDeviceData, ThrowOnError>) => (options.client ?? client).post<MvpApiCreateDeviceResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/devices',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Device
 */
export const mvpApiUpdateDevice = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdateDeviceData, ThrowOnError>) => (options.client ?? client).post<MvpApiUpdateDeviceResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/devices/update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Device Pings
 */
export const mvpApiListDevicePings = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListDevicePingsData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListDevicePingsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/devices/pings',
    ...options
});

/**
 * List Store Pings
 */
export const mvpApiListStorePings = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListStorePingsData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListStorePingsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/store-pings',
    ...options
});

/**
 * List Store Pongs
 */
export const mvpApiListStorePongs = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListStorePongsData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListStorePongsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/store-pongs',
    ...options
});

/**
 * List Cv Update Requests
 */
export const mvpApiListCvUpdateRequests = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListCvUpdateRequestsData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListCvUpdateRequestsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/cv-update-requests',
    ...options
});

/**
 * List Cv Update Responses
 */
export const mvpApiListCvUpdateResponses = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListCvUpdateResponsesData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListCvUpdateResponsesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/cv-update-responses',
    ...options
});

/**
 * Check Device Validity
 */
export const mvpApiCheckDeviceValidity = <ThrowOnError extends boolean = false>(options: Options<MvpApiCheckDeviceValidityData, ThrowOnError>) => (options.client ?? client).get<MvpApiCheckDeviceValidityResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/device-check/{serial_number}',
    ...options
});

/**
 * List Chargers
 */
export const mvpApiListChargers = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListChargersData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListChargersResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/chargers',
    ...options
});

/**
 * Create Charger
 */
export const mvpApiCreateCharger = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateChargerData, ThrowOnError>) => (options.client ?? client).post<MvpApiCreateChargerResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/chargers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Charger
 */
export const mvpApiUpdateCharger = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdateChargerData, ThrowOnError>) => (options.client ?? client).post<MvpApiUpdateChargerResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/chargers/update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Video Captures
 */
export const mvpApiListVideoCaptures = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListVideoCapturesData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListVideoCapturesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/video-captures',
    ...options
});

/**
 * List Videos
 */
export const mvpApiListVideos = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListVideosData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListVideosResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/videos',
    ...options
});

/**
 * Create Video
 */
export const mvpApiCreateVideo = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateVideoData, ThrowOnError>) => (options.client ?? client).post<MvpApiCreateVideoResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/videos',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Video
 */
export const mvpApiGetVideo = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetVideoData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetVideoResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/videos/{video_id}',
    ...options
});

/**
 * Update Video Tags
 */
export const mvpApiUpdateVideoTags = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdateVideoTagsData, ThrowOnError>) => (options.client ?? client).patch<MvpApiUpdateVideoTagsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/videos/{video_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Video Exports
 */
export const mvpApiListVideoExports = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListVideoExportsData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListVideoExportsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/video-export-requests',
    ...options
});

/**
 * Create Video Export Request
 */
export const mvpApiCreateVideoExportRequest = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateVideoExportRequestData, ThrowOnError>) => (options.client ?? client).post<MvpApiCreateVideoExportRequestResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/video-export-requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Video Export Request
 */
export const mvpApiGetVideoExportRequest = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetVideoExportRequestData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetVideoExportRequestResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/video-export-requests/{export_id}',
    ...options
});

/**
 * Register Video Images
 */
export const mvpApiRegisterVideoImages = <ThrowOnError extends boolean = false>(options: Options<MvpApiRegisterVideoImagesData, ThrowOnError>) => (options.client ?? client).post<MvpApiRegisterVideoImagesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/videos/{video_id}/register-images',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Video Tag Names
 */
export const mvpApiListVideoTagNames = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListVideoTagNamesData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListVideoTagNamesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/video-tag-names',
    ...options
});

/**
 * Create Video Tag Name
 */
export const mvpApiCreateVideoTagName = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateVideoTagNameData, ThrowOnError>) => (options.client ?? client).post<MvpApiCreateVideoTagNameResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/video-tag-names',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Video Tag Name
 */
export const mvpApiGetVideoTagName = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetVideoTagNameData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetVideoTagNameResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/video-tag-names/{tag_name_id}',
    ...options
});

/**
 * Update Video Tag Name
 */
export const mvpApiUpdateVideoTagName = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdateVideoTagNameData, ThrowOnError>) => (options.client ?? client).patch<MvpApiUpdateVideoTagNameResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/video-tag-names/{tag_name_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Video Time Tags
 */
export const mvpApiListVideoTimeTags = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListVideoTimeTagsData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListVideoTimeTagsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/video-time-tags',
    ...options
});

/**
 * Create Video Time Tag
 */
export const mvpApiCreateVideoTimeTag = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateVideoTimeTagData, ThrowOnError>) => (options.client ?? client).post<MvpApiCreateVideoTimeTagResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/video-time-tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Video Time Tag
 */
export const mvpApiDeleteVideoTimeTag = <ThrowOnError extends boolean = false>(options: Options<MvpApiDeleteVideoTimeTagData, ThrowOnError>) => (options.client ?? client).delete<MvpApiDeleteVideoTimeTagResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/video-time-tags/{time_tag_id}',
    ...options
});

/**
 * Get Video Time Tag
 */
export const mvpApiGetVideoTimeTag = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetVideoTimeTagData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetVideoTimeTagResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/video-time-tags/{time_tag_id}',
    ...options
});

/**
 * Get Video Tags For Store
 */
export const mvpApiGetVideoTagsForStore = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetVideoTagsForStoreData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetVideoTagsForStoreResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/video-tags/{store_id}',
    ...options
});

/**
 * Update Video Status
 */
export const mvpApiUpdateVideoStatus = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdateVideoStatusData, ThrowOnError>) => (options.client ?? client).post<MvpApiUpdateVideoStatusResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/video-status/{video_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Video Property Data
 */
export const mvpApiUpdateVideoPropertyData = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdateVideoPropertyDataData, ThrowOnError>) => (options.client ?? client).post<MvpApiUpdateVideoPropertyDataResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/video-metadata/{video_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Image Urls
 */
export const mvpApiGetImageUrls = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetImageUrlsData, ThrowOnError>) => (options.client ?? client).post<MvpApiGetImageUrlsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/images',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Image Gallery Urls
 */
export const mvpApiGetImageGalleryUrls = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetImageGalleryUrlsData, ThrowOnError>) => (options.client ?? client).post<MvpApiGetImageGalleryUrlsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/images/gallery',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Single Image Urls
 */
export const mvpApiGetSingleImageUrls = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetSingleImageUrlsData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetSingleImageUrlsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/images/{image_id}',
    ...options
});

/**
 * Get Signed Image Url
 */
export const mvpApiGetSignedImageUrl = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetSignedImageUrlData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetSignedImageUrlResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/images/{image_id}/signed',
    ...options
});

/**
 * Get Image Rotation
 */
export const mvpApiGetImageRotation = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetImageRotationData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetImageRotationResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/images/{image_id}/rotation',
    ...options
});

/**
 * Sign Imgix Url
 */
export const mvpApiSignImgixUrl = <ThrowOnError extends boolean = false>(options: Options<MvpApiSignImgixUrlData, ThrowOnError>) => (options.client ?? client).post<MvpApiSignImgixUrlResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/imgix/sign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Jobs
 */
export const mvpApiListJobs = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListJobsData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListJobsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/jobs',
    ...options
});

/**
 * Create Job
 */
export const mvpApiCreateJob = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateJobData, ThrowOnError>) => (options.client ?? client).post<MvpApiCreateJobResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/jobs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Jobs In Flight
 */
export const mvpApiListJobsInFlight = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListJobsInFlightData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListJobsInFlightResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/jobs-in-flight',
    ...options
});

/**
 * List Video Jobs
 */
export const mvpApiListVideoJobs = <ThrowOnError extends boolean = false>(options: Options<MvpApiListVideoJobsData, ThrowOnError>) => (options.client ?? client).post<MvpApiListVideoJobsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/video-jobs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Job
 */
export const mvpApiGetJob = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetJobData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetJobResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/jobs/{job_id}',
    ...options
});

/**
 * Update Job
 */
export const mvpApiUpdateJob = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdateJobData, ThrowOnError>) => (options.client ?? client).patch<MvpApiUpdateJobResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/jobs/{job_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Job Log Tail
 */
export const mvpApiGetJobLogTail = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetJobLogTailData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetJobLogTailResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/jobs/{job_id}/log-tail',
    ...options
});

/**
 * Get Job File
 */
export const mvpApiGetJobFile = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetJobFileData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetJobFileResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/jobs/{job_id}/file/{filename}',
    ...options
});

/**
 * Update Job Stage
 */
export const mvpApiUpdateJobStage = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdateJobStageData, ThrowOnError>) => (options.client ?? client).post<MvpApiUpdateJobStageResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/jobs/{job_id}/update-stage',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark Started Job
 */
export const mvpApiMarkStartedJob = <ThrowOnError extends boolean = false>(options: Options<MvpApiMarkStartedJobData, ThrowOnError>) => (options.client ?? client).post<MvpApiMarkStartedJobResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/jobs/{job_id}/started',
    ...options
});

/**
 * Complete Job
 */
export const mvpApiCompleteJob = <ThrowOnError extends boolean = false>(options: Options<MvpApiCompleteJobData, ThrowOnError>) => (options.client ?? client).post<MvpApiCompleteJobResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/jobs/{job_id}/complete',
    ...options
});

/**
 * Error Out Job
 */
export const mvpApiErrorOutJob = <ThrowOnError extends boolean = false>(options: Options<MvpApiErrorOutJobData, ThrowOnError>) => (options.client ?? client).post<MvpApiErrorOutJobResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/jobs/{job_id}/error',
    ...options
});

/**
 * Stop Job
 */
export const mvpApiStopJob = <ThrowOnError extends boolean = false>(options: Options<MvpApiStopJobData, ThrowOnError>) => (options.client ?? client).post<MvpApiStopJobResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/jobs/{job_id}/stop',
    ...options
});

/**
 * Register Images
 */
export const mvpApiRegisterImages = <ThrowOnError extends boolean = false>(options: Options<MvpApiRegisterImagesData, ThrowOnError>) => (options.client ?? client).post<MvpApiRegisterImagesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/jobs/{job_id}/register-images',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Job Tasks
 */
export const mvpApiListJobTasks = <ThrowOnError extends boolean = false>(options: Options<MvpApiListJobTasksData, ThrowOnError>) => (options.client ?? client).get<MvpApiListJobTasksResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/jobs/{job_id}/tasks',
    ...options
});

/**
 * Create Job Tasks
 */
export const mvpApiCreateJobTasks = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateJobTasksData, ThrowOnError>) => (options.client ?? client).post<MvpApiCreateJobTasksResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/jobs/{job_id}/tasks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Job Task
 */
export const mvpApiGetJobTask = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetJobTaskData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetJobTaskResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/jobs/{job_id}/tasks/{task_id}',
    ...options
});

/**
 * Get Job Task Parcels
 */
export const mvpApiGetJobTaskParcels = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetJobTaskParcelsData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetJobTaskParcelsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/jobs/{job_id}/tasks/{task_id}/parcels',
    ...options
});

/**
 * Complete Job Task
 */
export const mvpApiCompleteJobTask = <ThrowOnError extends boolean = false>(options: Options<MvpApiCompleteJobTaskData, ThrowOnError>) => (options.client ?? client).patch<MvpApiCompleteJobTaskResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/jobs/{job_id}/tasks/{task_id}/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Skip Job Task
 */
export const mvpApiSkipJobTask = <ThrowOnError extends boolean = false>(options: Options<MvpApiSkipJobTaskData, ThrowOnError>) => (options.client ?? client).patch<MvpApiSkipJobTaskResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/jobs/{job_id}/tasks/{task_id}/skip',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Next Pending Job Task
 */
export const mvpApiGetNextPendingJobTask = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetNextPendingJobTaskData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetNextPendingJobTaskResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/jobs/{job_id}/next-pending-task',
    ...options
});

/**
 * List All Job Tasks
 */
export const mvpApiListAllJobTasks = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListAllJobTasksData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListAllJobTasksResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/job-tasks',
    ...options
});

/**
 * Update Job Task Metadata
 */
export const mvpApiUpdateJobTaskMetadata = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdateJobTaskMetadataData, ThrowOnError>) => (options.client ?? client).patch<MvpApiUpdateJobTaskMetadataResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/job-tasks/{task_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Task Activity
 */
export const mvpApiTaskActivity = <ThrowOnError extends boolean = false>(options: Options<MvpApiTaskActivityData, ThrowOnError>) => (options.client ?? client).post<MvpApiTaskActivityResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/tasks/{task_id}/activity',
    ...options
});

/**
 * Create Review Tasks
 */
export const mvpApiCreateReviewTasks = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateReviewTasksData, ThrowOnError>) => (options.client ?? client).post<MvpApiCreateReviewTasksResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/review-tasks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Clone Review Tasks
 */
export const mvpApiCloneReviewTasks = <ThrowOnError extends boolean = false>(options: Options<MvpApiCloneReviewTasksData, ThrowOnError>) => (options.client ?? client).post<MvpApiCloneReviewTasksResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/review-tasks/clone',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Benchmark Jobs
 */
export const mvpApiCreateBenchmarkJobs = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateBenchmarkJobsData, ThrowOnError>) => (options.client ?? client).post<MvpApiCreateBenchmarkJobsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/qc-benchmarks/jobs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List My Benchmark Jobs
 */
export const mvpApiListMyBenchmarkJobs = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListMyBenchmarkJobsData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListMyBenchmarkJobsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/qc-benchmarks/jobs/mine',
    ...options
});

/**
 * Get Benchmark Job Metrics
 *
 * This quiz's results, for the reviewer who took it or for staff.
 *
 * Unlike /jobs/mine the caller does name a quiz, so ownership is checked rather
 * than implied: a reviewer reaches their own results and nobody else's. Staff
 * and superusers see any quiz — the same people who can create them in the
 * admin. `is_authenticated` is checked first because an internal-API-key caller
 * has an AnonymousUser with no email to compare.
 */
export const mvpApiGetBenchmarkJobMetrics = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetBenchmarkJobMetricsData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetBenchmarkJobMetricsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/qc-benchmarks/jobs/{job_sid}/metrics',
    ...options
});

/**
 * List Injected Benchmark Metrics
 *
 * Per-labeler accuracy over silently injected benchmark tasks (see mvp.benchmark).
 *
 * Staff-only: unlike the announced-quiz metrics above, this covers every
 * labeler at once rather than one reviewer's own quiz. Defaults to the last
 * 30 days when no window is given.
 */
export const mvpApiListInjectedBenchmarkMetrics = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListInjectedBenchmarkMetricsData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListInjectedBenchmarkMetricsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/qc-benchmarks/injected/metrics',
    ...options
});

/**
 * Get My Injected Benchmark Metrics
 *
 * This labeler's own accuracy over silently injected benchmark tasks.
 *
 * Scoped server-side from the authenticated identity, the same rule
 * `benchmark_jobs_for_reviewer` follows — a caller never gets to name whose
 * numbers they see. Zero-filled rather than 404 when the labeler has no
 * injected tasks in the window yet.
 */
export const mvpApiGetMyInjectedBenchmarkMetrics = <ThrowOnError extends boolean = false>(options?: Options<MvpApiGetMyInjectedBenchmarkMetricsData, ThrowOnError>) => (options?.client ?? client).get<MvpApiGetMyInjectedBenchmarkMetricsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/qc-benchmarks/injected/metrics/mine',
    ...options
});

/**
 * Get Injection Pool Status
 *
 * Per-store injection pool health: eligible gold candidates and 24h usage.
 *
 * Staff-only operational visibility. With per-store scoping and per-user
 * exclusion, a thin store's pool running dry is the expected early failure
 * mode, not an edge case — without this, an under-filled daily budget is
 * invisible.
 */
export const mvpApiGetInjectionPoolStatus = <ThrowOnError extends boolean = false>(options?: Options<MvpApiGetInjectionPoolStatusData, ThrowOnError>) => (options?.client ?? client).get<MvpApiGetInjectionPoolStatusResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/qc-benchmarks/injected/pool',
    ...options
});

/**
 * List Tool Websites
 */
export const mvpApiListToolWebsites = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListToolWebsitesData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListToolWebsitesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/tool-websites',
    ...options
});

/**
 * Should Show Staff Tool
 */
export const mvpApiShouldShowStaffTool = <ThrowOnError extends boolean = false>(options?: Options<MvpApiShouldShowStaffToolData, ThrowOnError>) => (options?.client ?? client).get<MvpApiShouldShowStaffToolResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/should-show-staff-tool',
    ...options
});

/**
 * List Oos Parcels
 */
export const mvpApiListOosParcels = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListOosParcelsData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListOosParcelsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/oos-parcels',
    ...options
});

/**
 * Get Oos Parcel
 */
export const mvpApiGetOosParcel = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetOosParcelData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetOosParcelResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/oos-parcels/{parcel_id}',
    ...options
});

/**
 * List Oos Event Buffer
 */
export const mvpApiListOosEventBuffer = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListOosEventBufferData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListOosEventBufferResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/oos-event-buffer',
    ...options
});

/**
 * Get Oos Event From Buffer
 */
export const mvpApiGetOosEventFromBuffer = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetOosEventFromBufferData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetOosEventFromBufferResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/oos-event-buffer/{event_id}',
    ...options
});

/**
 * List Oos Event Batches
 */
export const mvpApiListOosEventBatches = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListOosEventBatchesData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListOosEventBatchesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/oos-event-batches',
    ...options
});

/**
 * Get Oos Event Batch
 */
export const mvpApiGetOosEventBatch = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetOosEventBatchData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetOosEventBatchResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/oos-event-batches/{batch_id}',
    ...options
});

/**
 * List Planograms
 */
export const mvpApiListPlanograms = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListPlanogramsData, ThrowOnError>) => (options?.client ?? client).get<MvpApiListPlanogramsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/planograms',
    ...options
});

/**
 * Create Planogram
 */
export const mvpApiCreatePlanogram = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreatePlanogramData, ThrowOnError>) => (options.client ?? client).post<MvpApiCreatePlanogramResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/planograms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Planogram
 */
export const mvpApiGetPlanogram = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetPlanogramData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetPlanogramResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/planograms/{planogram_id}',
    ...options
});

/**
 * Get Planogram Label
 */
export const mvpApiGetPlanogramLabel = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetPlanogramLabelData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetPlanogramLabelResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/planograms/{planogram_id}/labels/{label_uuid}',
    ...options
});

/**
 * Update Planogram Label
 */
export const mvpApiUpdatePlanogramLabel = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdatePlanogramLabelData, ThrowOnError>) => (options.client ?? client).patch<MvpApiUpdatePlanogramLabelResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/planograms/{planogram_id}/labels/{label_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Planogram Images
 */
export const mvpApiListPlanogramImages = <ThrowOnError extends boolean = false>(options: Options<MvpApiListPlanogramImagesData, ThrowOnError>) => (options.client ?? client).get<MvpApiListPlanogramImagesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/planograms/{planogram_id}/images',
    ...options
});

/**
 * Create Planogram Images
 */
export const mvpApiCreatePlanogramImages = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreatePlanogramImagesData, ThrowOnError>) => (options.client ?? client).post<MvpApiCreatePlanogramImagesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/planograms/{planogram_id}/images',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Planogram Image
 */
export const mvpApiGetPlanogramImage = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetPlanogramImageData, ThrowOnError>) => (options.client ?? client).get<MvpApiGetPlanogramImageResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/planograms/{planogram_id}/images/{label_uuid}',
    ...options
});

/**
 * Get Stores Inventory
 */
export const mvpApiGetStoresInventory = <ThrowOnError extends boolean = false>(options?: Options<MvpApiGetStoresInventoryData, ThrowOnError>) => (options?.client ?? client).get<MvpApiGetStoresInventoryResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/inventory/stores',
    ...options
});

/**
 * Get Devices Inventory
 */
export const mvpApiGetDevicesInventory = <ThrowOnError extends boolean = false>(options?: Options<MvpApiGetDevicesInventoryData, ThrowOnError>) => (options?.client ?? client).get<MvpApiGetDevicesInventoryResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/v1/inventory/devices',
    ...options
});
